import React from "react";
import useWindowDimensions from "../../../functions/windows";
import { IndexTableComponent } from "../TableDatabase";
import { CardDatabase, Container } from "./index.styles";

type IProps = {
  database: Array<string | JSX.Element>[];
};
export default function InfomationDatabase(props: IProps) {
  const { database } = props;
  const {height} = useWindowDimensions()
  const [dataStorage, setDataStorage] = React.useState<any[][]>(database);
  const [indexData, setIndexData] = React.useState<number>(0);
  const [dataforShow, setDataForShow] = React.useState<Array<any>[]>([]);

  const MAX_NUMBER_OF_COMPONENTS = height < 668 ? 2 : 3;

  const getNumOfIndex = React.useCallback(
    () =>
      dataStorage.length % MAX_NUMBER_OF_COMPONENTS === 0
        ? Math.floor(dataStorage.length / MAX_NUMBER_OF_COMPONENTS)
        : Math.floor(dataStorage.length / MAX_NUMBER_OF_COMPONENTS) + 1,
    [dataStorage, MAX_NUMBER_OF_COMPONENTS]
  );

  const [dataIndex, setDataIndex] = React.useState<number>(getNumOfIndex());

  const setRangeData = React.useCallback(() => {
    const startData = indexData * MAX_NUMBER_OF_COMPONENTS;
    const endData =
      startData + MAX_NUMBER_OF_COMPONENTS > dataStorage.length
        ? dataStorage.length
        : startData + MAX_NUMBER_OF_COMPONENTS;
    setDataIndex(getNumOfIndex());
    setDataForShow(dataStorage.slice(startData, endData));
  }, [dataStorage, indexData, getNumOfIndex, MAX_NUMBER_OF_COMPONENTS]);

  React.useEffect(setRangeData, [indexData, setIndexData, setRangeData]);

  // Set data when parent change data
  const handleChangeData = React.useCallback(() => {
    if (database.length === dataStorage.length) return;
    setDataStorage(database);
  }, [database, dataStorage.length, setDataStorage]);
  React.useEffect(handleChangeData, [database, handleChangeData]);

  // Reset index when changed data
  React.useEffect(() => {
    setIndexData(0);
  }, [dataStorage]);

  const increaseIndex = () => {
    const newIndex = indexData + 1;
    if (newIndex >= dataIndex) return;
    setIndexData(newIndex);
  };

  const reduceIndex = () => {
    const newIndex = indexData - 1;
    if (newIndex <= -1) return;
    setIndexData(newIndex);
  };

  return (
    <Container>
      {dataforShow.map((data, index) => [
        <CardDatabase key={index}>
          {data.map((element, i) => (
            <div key={i}>{element}</div>
          ))}
        </CardDatabase>,
      ])}
      {dataIndex !== 0 && (
        <IndexTableComponent
          reduceIndex={reduceIndex}
          increaseIndex={increaseIndex}
          current={indexData}
          numOfIndex={dataIndex}
          onPressItem={(index) => setIndexData(index - 1)}
        />
      )}
    </Container>
  );
}
